const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ArticleCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.1,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 20,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('article-carousel')) {
  customElements.define('article-carousel', ArticleCarousel)
}
